import { useLanguage } from '../utils/LanguageContext';
import translations from '../components/ComponentsTranslations.lang.json';
import { updateUserMaritalStatusSchema } from '../shared/validations/userValidations';
import { ValidatedForm, FormSubmit, FormChoice } from './common/ValidatedForm';
import { MaritalStatus } from '../shared/constants/userConstants';
import { useAuth } from '../utils/AuthContext.js';

const MaritalStatusForm = ({ onFinish }) => {
  const { lang, optionsForEnum } = useLanguage(translations);
  const { user, api } = useAuth();

  return (
    <ValidatedForm
      key="userMaritalStatus"
      schema={updateUserMaritalStatusSchema}
      initialValues={{ maritalStatus: user.maritalStatus }}
      handleSubmit={api.updateUserMaritalStatus}
      onFinish={onFinish}
    >
      <FormChoice name="maritalStatus" options={optionsForEnum(MaritalStatus)} type="select" />
      <FormSubmit>{lang('update')}</FormSubmit>
    </ValidatedForm>
  );
};

export default MaritalStatusForm;
